// extracted by css-extract-rspack-plugin
export default {"colorGray9":"#dddddd","connector":"connector__connector___SOz73","invisible":"connector__invisible___L5Uld"};